import { HorizontalStack, Icon } from '@ztechapps/webui.util'
import { useAiChatContext } from './Context'
import styles from './styles.module.css'

export type LoadingIndicatorProps = {
  /** Whether to show the loading indicator */
  isLoading: boolean
}

/**
 * LoadingIndicator component shows a typing/thinking animation
 * when the AI is generating a response.
 */
export const LoadingIndicator = ({ isLoading }: LoadingIndicatorProps) => {
  const { assistantName } = useAiChatContext()

  if (!isLoading) {
    return null
  }

  return (
    <div className="d-flex justify-content-start mb-2">
      <div className={`p-3 rounded-3 bg-secondary-subtle text-body ${styles.loadingBubble}`}>
        <HorizontalStack gap={2} className="small opacity-75 mb-1">
          <Icon name="robot" />
          <span>{assistantName}</span>
        </HorizontalStack>
        <TypingDots />
      </div>
    </div>
  )
}

/**
 * TypingDots component displays an animated typing indicator
 */
const TypingDots = () => {
  return (
    <div className="d-flex gap-1 py-1">
      <TypingDot delay={0} />
      <TypingDot delay={0.2} />
      <TypingDot delay={0.4} />
    </div>
  )
}

type TypingDotProps = {
  delay: number
}

const TypingDot = ({ delay }: TypingDotProps) => {
  return <span className={`rounded-circle bg-secondary ${styles.typingDot}`} style={{ animationDelay: `${delay}s` }} />
}
